(function(){
  function setState(sc){var h=document.getElementById('ikHeader');if(!h)return;if(sc){h.classList.add('scrolled');}else{h.classList.remove('scrolled');}}
  window.ikOpenSearch=function(){var o=document.getElementById('ikSearchOv');if(!o)return;o.classList.add('on');var i=document.getElementById('ikSearchInput');if(i){i.value='';setTimeout(function(){i.focus();},40);}};
  window.ikopenSearch=window.ikOpenSearch;
  window.ikCloseSearch=function(){var o=document.getElementById('ikSearchOv');if(o)o.classList.remove('on');};
  function init(){
    var s=document.getElementById('ikSentinel');
    function loop(){
      if(s){ setState(s.getBoundingClientRect().top < -40); }
      else { var y=window.scrollY||window.pageYOffset||(document.scrollingElement&&document.scrollingElement.scrollTop)||document.documentElement.scrollTop||0; setState(y>40); }
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
    var t=document.getElementById('ikToggle'),m=document.getElementById('ikMobile');
    if(t&&m){
      t.addEventListener('click',function(){t.classList.toggle('active');m.classList.toggle('active');document.body.style.overflow=m.classList.contains('active')?'hidden':'';});
      m.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){t.classList.remove('active');m.classList.remove('active');document.body.style.overflow='';});});
    }
    var sb=document.getElementById('ikSearchBtn'); if(sb)sb.addEventListener('click',window.ikOpenSearch);
    var ov=document.getElementById('ikSearchOv'); if(ov)ov.addEventListener('click',function(e){if(e.target===ov)window.ikCloseSearch();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')window.ikCloseSearch();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
